/* eanae-home.js — 홈 인터랙션.
   (1) 가로 레일 마우스 드래그 스크롤(products·social). 시각 요소는 추가하지 않음 — 터치/트랙패드는 네이티브 스크롤.
   (2) 쿠션 셰이드 선택: 스와치 클릭 → 섹션 배경 + 잉크 대비 전환 + 해당 톤 팬컷 교체 + 셰이드명 갱신.
       기본값은 **미선택(타워컷)** — 배경 아이보리, 캡션 "Escolha um tom". 선택된 스와치를 다시 누르면 미선택으로 복귀(fb2).

   대비 전환은 임계값 상수가 아니라 두 후보(흰색/잉크)의 실제 WCAG 대비를 직접 비교한다.
   (이전 구현의 `lum < 0.58` 상수는 실제 교차점 L≈0.19에서 크게 벗어나 중간 톤에서 흰 글자가 깨졌다.) */
(function () {
  "use strict";

  var INK = "#241E17";
  var WHITE = "#FFFFFF";

  /* ---------- 가로 레일 드래그 ---------- */
  function bindRail(rail) {
    if (!rail || rail.__eaBound) return;
    rail.__eaBound = 1;
    var down = false, sx = 0, sl = 0, moved = false;
    rail.addEventListener("mousedown", function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft;
    });
    window.addEventListener("mousemove", function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 5) moved = true;
      rail.scrollLeft = sl - dx;
      e.preventDefault();
    }, { passive: false });
    window.addEventListener("mouseup", function () {
      if (!down) return;
      down = false;
      setTimeout(function () { moved = false; }, 30);
    });
    rail.addEventListener("dragstart", function (e) { e.preventDefault(); });
    // 드래그 후 발생하는 클릭은 카드 이동을 막는다(capture 단계)
    rail.addEventListener("click", function (e) {
      if (!moved) return;
      var a = e.target.closest && e.target.closest("a");
      if (a) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  /* ---------- WCAG 상대휘도 / 대비 ---------- */
  function lum(hex) {
    var h = String(hex).replace("#", "");
    function ch(i) {
      var c = parseInt(h.substr(i, 2), 16) / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * ch(0) + 0.7152 * ch(2) + 0.0722 * ch(4);
  }
  function ratio(a, b) {
    return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
  }

  /* ---------- 쿠션 ---------- */
  var TOWER_IMG = "eanae-cushion-6.jpg"; // 미선택 기본 상태 = 10톤 타워컷
  var TOWER_BG = "#F1ECE2";

  function bindCushion() {
    var sec = document.querySelector("[data-cush]");
    if (!sec) return;
    var D = window.EANAE_DATA;
    var SH = (D && D.SHADES) || [];
    if (!SH.length) return;

    var photo = sec.querySelector("[data-cush-photo]");
    var nameEl = sec.querySelector("[data-cush-name]");
    var dots = [].slice.call(sec.querySelectorAll("[data-shade-dot]"));
    var idx = null; // null = 미선택(타워컷)

    function pickLabel() {
      var v = (D.UI || {}).shadePick || {};
      var lang = window.EANAE_LANG ? window.EANAE_LANG.get() : "pt";
      return v[lang] != null ? v[lang] : v.pt || "";
    }

    function render() {
      var cur = idx === null ? null : SH[idx];
      var bg = cur ? cur.c : TOWER_BG;
      var L = lum(bg);
      var dark = ratio(L, lum(WHITE)) > ratio(L, lum(INK));
      var ink = dark ? WHITE : INK;
      // 작은 트래킹 텍스트(eyebrow·셰이드명)도 잉크와 같은 불투명 색을 쓴다.
      // 330 Caramel 배경에서는 어떤 투명도를 줘도 4.5:1을 넘기지 못한다 — 위계는 크기·자간으로.
      var line = dark ? "rgba(255,255,255,.55)" : "rgba(36,30,23,.55)";
      sec.style.setProperty("--cush-bg", bg);
      sec.style.setProperty("--cush-ink", ink);
      sec.style.setProperty("--cush-line", line);
      if (nameEl) nameEl.textContent = cur ? cur.n : pickLabel();
      dots.forEach(function (d, i) {
        d.style.boxShadow = i === idx
          ? "inset 0 0 0 1px rgba(0,0,0,.14), 0 0 0 2px " + ink
          : "inset 0 0 0 1px rgba(0,0,0,.14)";
        d.setAttribute("aria-pressed", i === idx ? "true" : "false");
      });
      if (photo) {
        // 새 사진이 디코드된 뒤 교체 — src를 즉시 바꾸면 로드되는 동안 빈 칸이 보인다.
        var next = eanaeAsset(cur ? "eanae-cushion-" + String(cur.n).split(" ")[0] + ".jpg" : TOWER_IMG);
        var token = idx;
        var pre = new Image();
        pre.onload = function () {
          if (idx === token) photo.src = next;
        };
        pre.src = next;
      }
    }

    dots.forEach(function (d, i) {
      // 같은 스와치를 다시 누르면 미선택(타워컷)으로 복귀.
      d.addEventListener("click", function () { idx = idx === i ? null : i; render(); });
    });
    // 셰이드명은 .i18n 스왑 대상이 아니라 이 함수가 두 상태를 모두 소유한다.
    window.addEventListener("eanae-lang-change", render);
    render();
  }

  function init() {
    [].slice.call(document.querySelectorAll("[data-rail]")).forEach(bindRail);
    if (window.EANAE_DATA) bindCushion();
    else window.addEventListener("eanae-data-ready", bindCushion);
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
